//Reducer Types
export interface NavState {
	user: number;
	matches: number;
	cruise: number;
}
export interface Nav {
	nav: NavState;
}
interface UserNavCount {
	type: "NAV_USER_COUNT";
	payload: {
		user: number;
	};
}

interface UserMatchesCount {
	type: "NAV_MATCHES_COUNT";
	payload: {
		matches: number;
	};
}
interface UserCruiseCount {
	type: "NAV_CRUISE_COUNT";
	payload: {
		cruise: number;
	};
}
type Action = UserNavCount | UserMatchesCount | UserCruiseCount;

export const navCountReducer = (
	state: NavState = {
		user: 0,
		matches: 0,
		cruise: 0,
	},
	action: Action
): NavState => {
	switch (action.type) {
		case "NAV_USER_COUNT":
			return {
				...state,
				user: action.payload.user,
			};
		case "NAV_MATCHES_COUNT":
			return {
				...state,
				matches: action.payload.matches,
			};
		case "NAV_CRUISE_COUNT":
			return {
				...state,
				cruise: action.payload.cruise,
			};

		default:
			return state;
	}
};
